<template>
    <span v-if="onlyValue" :class="[{ 'text-danger': value < 0 }, { 'text-success': value >= 0 }]">
        ${{ formatCurrency(value) }}
    </span>
    <div v-else :class="['section-group-data', { 'side-by-side': sideBySide }]">
        <div class="section-group-title">{{ title }}</div>
        <div
            :style="`max-width: 300px; text-align: ${sideBySide ? 'right' : 'left'}`"
            v-if="!editMode"
            :class="[
                { disabled: !value },
                { 'text-danger': !noColor && value < 0 },
                { 'text-success': !noColor && value >= 0 },
            ]"
        >
            ${{ formatCurrency(Math.abs(value)) }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: String,
        value: [String, Number],
        editMode: Boolean,
        sideBySide: Boolean,
        onlyValue: Boolean,
        noColor: Boolean,
    },
    methods: {
        /**
         * Format a numeric value as currency with 2 decimal places
         * Handles null/undefined and returns "0.00" as fallback
         */
        formatCurrency(value) {
            const num = Number(value)
            if (isNaN(num)) return "0.00"
            return num.toFixed(2)
        },
    },
}
</script>

<style lang="scss" scoped>
.section-group-data {
    display: flex;
    margin: 10px 0;
    gap: 15px;
    & .disabled {
        color: #bbb;
    }
}
.side-by-side {
    justify-content: space-between;
    .section-group-title {
        min-width: 0;
    }
}
.section-group-title {
    min-width: 250px;
    font-weight: bold;
}
</style>
